// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EasyHost-container-wGFjP {
	width: 100%;
	max-width: var(--max-content-width);
	margin: 0 auto;
	padding: 0 15px;
}

.EasyHost-bgColor-ekYvn {
	background-color: var(--btn-primary-bg);
	border-radius: 12px;
	padding: 60px;
}

.EasyHost-heading-rQZiJ {
	font-size: 48px;
	font-weight: 600;
	color: var(--white-text);
	text-align: center;
	margin: 0 0 32px;
}

.EasyHost-desc-lGbLs {
	font-size: 18px;
	color: var(--subNavbar-text-color);
	margin-bottom: 0;
}

.EasyHost-margintop20-F47cD {
	margin-top: 20px;
}

.EasyHost-centerFlex-WJblz {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	color: var(--white-text);
	gap: 60px;
}

.EasyHost-imgWidth-pauO1 {
	max-width: 140px;
	-o-object-fit: contain;
	   object-fit: contain;
}

.EasyHost-columnPaddingOne-OqiJr {
	padding-right: 45px !important;
}

.EasyHost-columnThreePadding-KQ86p {
	padding-left: 45px !important;
}

.EasyHost-textWhite-lm7Q0 {
	color: var(--white-text);
}

@media (max-width:1024px) and (min-width:768px) {
	.EasyHost-centerFlex-WJblz {
		-ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		gap: 15px;
	}
}

@media (max-width: 767px) {
	.EasyHost-heading-rQZiJ {
		font-size: 40px;
	}

	.EasyHost-centerFlex-WJblz {
		-ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		gap: 15px;
	}

	.EasyHost-bgColor-ekYvn {
		padding: 30px;
	}

	.EasyHost-columnPaddingOne-OqiJr {
		padding-right: 15px;
		padding-bottom: 24px;
	}

	.EasyHost-columnThreePadding-KQ86p {
		padding-left: 15px;
		padding-top: 24px;
	}

	.EasyHost-columnThreePadding-KQ86p {
		padding-left: 15px !important;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/WhyHost/EasyHost/EasyHost.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,mCAAmC;CACnC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,uCAAuC;CACvC,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,wBAAwB;CACxB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAwB;CACxB,SAAS;AACV;;AAEA;CACC,gBAAgB;CAChB,sBAAmB;IAAnB,mBAAmB;AACpB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC;EACC,mBAAe;MAAf,eAAe;EACf,SAAS;CACV;AACD;;AAEA;CACC;EACC,eAAe;CAChB;;CAEA;EACC,mBAAe;MAAf,eAAe;EACf,SAAS;CACV;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,mBAAmB;EACnB,oBAAoB;CACrB;;CAEA;EACC,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,6BAA6B;CAC9B;AACD","sourcesContent":[".container {\n\twidth: 100%;\n\tmax-width: var(--max-content-width);\n\tmargin: 0 auto;\n\tpadding: 0 15px;\n}\n\n.bgColor {\n\tbackground-color: var(--btn-primary-bg);\n\tborder-radius: 12px;\n\tpadding: 60px;\n}\n\n.heading {\n\tfont-size: 48px;\n\tfont-weight: 600;\n\tcolor: var(--white-text);\n\ttext-align: center;\n\tmargin: 0 0 32px;\n}\n\n.desc {\n\tfont-size: 18px;\n\tcolor: var(--subNavbar-text-color);\n\tmargin-bottom: 0;\n}\n\n.margintop20 {\n\tmargin-top: 20px;\n}\n\n.centerFlex {\n\tdisplay: flex;\n\tcolor: var(--white-text);\n\tgap: 60px;\n}\n\n.imgWidth {\n\tmax-width: 140px;\n\tobject-fit: contain;\n}\n\n.columnPaddingOne {\n\tpadding-right: 45px !important;\n}\n\n.columnThreePadding {\n\tpadding-left: 45px !important;\n}\n\n.textWhite {\n\tcolor: var(--white-text);\n}\n\n@media (max-width:1024px) and (min-width:768px) {\n\t.centerFlex {\n\t\tflex-wrap: wrap;\n\t\tgap: 15px;\n\t}\n}\n\n@media (max-width: 767px) {\n\t.heading {\n\t\tfont-size: 40px;\n\t}\n\n\t.centerFlex {\n\t\tflex-wrap: wrap;\n\t\tgap: 15px;\n\t}\n\n\t.bgColor {\n\t\tpadding: 30px;\n\t}\n\n\t.columnPaddingOne {\n\t\tpadding-right: 15px;\n\t\tpadding-bottom: 24px;\n\t}\n\n\t.columnThreePadding {\n\t\tpadding-left: 15px;\n\t\tpadding-top: 24px;\n\t}\n\n\t.columnThreePadding {\n\t\tpadding-left: 15px !important;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EasyHost-container-wGFjP`,
	"bgColor": `EasyHost-bgColor-ekYvn`,
	"heading": `EasyHost-heading-rQZiJ`,
	"desc": `EasyHost-desc-lGbLs`,
	"margintop20": `EasyHost-margintop20-F47cD`,
	"centerFlex": `EasyHost-centerFlex-WJblz`,
	"imgWidth": `EasyHost-imgWidth-pauO1`,
	"columnPaddingOne": `EasyHost-columnPaddingOne-OqiJr`,
	"columnThreePadding": `EasyHost-columnThreePadding-KQ86p`,
	"textWhite": `EasyHost-textWhite-lm7Q0`
};
module.exports = ___CSS_LOADER_EXPORT___;
